import './DeviceRotate.scss';

import React from 'react';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';
import { useTranslation } from 'src/i18n';

export default function DeviceRotate () {
  const { t } = useTranslation();

  return (
    <>
      <div className='deviceRotateImg'>
        <ScreenRotationIcon style={{ fontSize: 40 }} />
      </div>
      <p className='deviceRotateText'>{t('ui.rotateDevice')}</p>
    </>
  );
}
